import { Badge } from "@/components/ui/badge";

const MAP = {
  in_attesa: { label: "In attesa", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  approvata: { label: "Approvata", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rifiutata: { label: "Rifiutata", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || MAP.in_attesa;
  return (
    <Badge
      variant="outline"
      data-testid={`status-badge-${status}`}
      className={`rounded-full border font-medium ${s.cls}`}
    >
      {s.label}
    </Badge>
  );
}
